import { createContext, useContext } from 'react';

// V71 — portal geneli görünürlük kararı (legacy anahtar + yetki motoru). HRLayout sağlar;
// sayfalar başka bir portal sayfasına link/kısayol çizmeden önce canSeePath ile sorar.
const HRAccessContext = createContext(null);

export const HRAccessProvider = HRAccessContext.Provider;

/** Portal dışında (sağlayıcı yokken) her yol görünür sayılır — mevcut davranış korunur. */
export const useHRAccess = () => {
  const ctx = useContext(HRAccessContext);
  return ctx || { canSeePath: () => true, engine: null };
};
